// Swiper-based replacement for the old slick.js carousel (dropped so this section no longer
// needs jQuery + slick.min.js + slick CSS). Swiper itself is loaded lazily, on demand, via the
// same window.ShopLCSwiperAssets loader header-drawer.js already uses, so nothing extra ships on
// pages without this section.
document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.js-social-impact-carousel');
  if (!roots.length) return;

  const ensureSwiperLoaded = () => {
    if (typeof window.Swiper !== 'undefined') return Promise.resolve();
    if (window.__shoplcSwiperLoading) return window.__shoplcSwiperLoading;

    const assets = window.ShopLCSwiperAssets || {};

    if (assets.css && !document.querySelector(`link[href="${assets.css}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = assets.css;
      document.head.append(link);
    }

    window.__shoplcSwiperLoading = new Promise((resolve) => {
      if (!assets.js) {
        resolve();
        return;
      }

      const existingScript = document.querySelector(`script[src="${assets.js}"]`);
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(), { once: true });
        existingScript.addEventListener('error', () => resolve(), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = assets.js;
      script.addEventListener('load', () => resolve());
      script.addEventListener('error', () => resolve());
      document.head.append(script);
    });

    return window.__shoplcSwiperLoading;
  };

  // slick used to treat every direct child of the container as a slide automatically. Swiper
  // needs an explicit .swiper-wrapper > .swiper-slide structure, so build it from whatever
  // markup the social_impact_images metaobject supplies - no content edit required.
  const wrapForSwiper = (root) => {
    const existing = root.querySelector(':scope > .swiper-wrapper');
    if (existing) return existing;

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    Array.from(root.children).forEach((child) => {
      child.classList.add('swiper-slide');
      wrapper.append(child);
    });

    root.classList.add('swiper');
    root.append(wrapper);

    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    root.append(pagination);

    return wrapper;
  };

  roots.forEach((root) => {
    if (root.dataset.swiperInited === '1') return;

    const wrapper = wrapForSwiper(root);
    const slideCount = wrapper.querySelectorAll(':scope > .swiper-slide').length;
    if (slideCount === 0) return;

    root.dataset.swiperInited = '1';

    if (slideCount === 1) {
      root.classList.add('swiper--static');
      return;
    }

    ensureSwiperLoaded().then(() => {
      if (typeof window.Swiper === 'undefined') return;

      // Swiper breakpoints are min-width (opposite of slick's max-width "responsive" array), so
      // the old base (>1244px: 1 centered slide) and the old 1244px-and-below override (2 slides,
      // no centering) are swapped here: mobile-first default is the old override, and the
      // 1245px breakpoint restores the old base.
      new window.Swiper(root, {
        loop: true,
        speed: 1000,
        slidesPerView: 2,
        centeredSlides: false,
        autoplay: { delay: 8000, disableOnInteraction: false },
        pagination: { el: root.querySelector('.swiper-pagination'), clickable: true },
        breakpoints: {
          1245: {
            slidesPerView: 1,
            centeredSlides: true,
          },
        },
      });
    });
  });
});
